<script setup lang="ts">
import packageJson from '../../../../../package.json';

const version = packageJson.version;
</script>

<template>
  <footer class="footer">
    <div class="content">
      <div class="title-container">
        <h1>VERA</h1>
        <span class="version">v{{ version }}</span>
      </div>

      <div class="columns">
        <div class="column">
          <p>Construction Engineering<br />Sweden Group</p>
          <p class="is-size-6">© CESG</p>
        </div>
        <div class="column">
          <p>
            <a href="mailto:info@cesg.se">info@cesg.se</a>
            <br />
            <a href="tel:+46760040410">+467600 40 410</a>
          </p>
        </div>
      </div>
    </div>
  </footer>
</template>
<style lang="scss" scoped>
footer {
  --bulma-footer-padding: 7rem 1.5rem 2rem 1.5rem;
  --bulma-footer-background-color: var(--primary-color);

  margin-top: 2rem;
  margin-bottom: 0 !important;
  color: white;

  .title-container {
    display: flex;
    align-items: baseline;
    gap: 10px; /* Space between title and version */
  }

  h1 {
    color: white;
    font-size: 8rem;
    font-weight: 700;
    margin: 0;
  }

  .version {
    font-size: 0.8rem;
    color: rgba(255, 255, 255, 0.7);
    align-self: flex-end;
    padding-bottom: 17px;
  }

  a {
    color: white;
  }
}
</style>
